import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import * as actions from '../actions';
import {getActiveLanguage, getTranslate} from "react-localize-redux/lib/index";

class BreadCrumbs extends Component {

    componentDidMount() {
        this.props.getBreadCrumbs();
    }

    render() {
        return (
            <div>
                {this.props.breadcrumbs.map((crumb, index) => {
                    return (
                        <span key={index}>
                            <i className='breadcrumb-name'>{crumb.toUpperCase()}</i>
                            {
                                this.props.breadcrumbs.length - 1 !== index ?
                                    <i className='material-icons'>arrow_forward</i> :
                                    null
                            }
                        </span>
                    );
                })}


            </div>
        );
    }

}

BreadCrumbs.propTypes = {
    breadcrumbs:    PropTypes.array,
    getBreadCrumbs: PropTypes.func,
}

function mapStateToProps(state) {
    return {
        breadcrumbs: state.breadcrumbs,
    }
};

export default connect(mapStateToProps, actions)(BreadCrumbs);



// WEBPACK FOOTER //
// ./src/components/BreadCrumbs.js